import Select, { components } from "react-select";

import { BsChevronDown } from "components/atoms/Icon/bs/BsChevronDown";

import Styles from "../../Styles.module.scss";

const customStyles = {
  container: (provided) => ({
    ...provided,
  }),
  control: (provided) => ({
    ...provided,
    borderRadius: "30px",
    backgroundColor: "#fff",
    border: "0.5px solid #ddd",
    padding: "0px 16px",
    boxShadow: "none",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#333333",
    fontSize: "16px",
    fontWeight: "400",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "4px 0px",
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: 20,
    overflow: "hidden",
    zIndex: 21,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    padding: "8px 16px",
    color: state.isSelected ? "#002A66" : "#333",
    background: state.isSelected || state.isFocused ? "#F1FBFF" : "",
    fontWeight: state.isSelected ? "600" : "normal",
  }),
  input: (provided) => ({
    ...provided,
  }),
  indicatorsContainer: () => ({
    border: "none",
  }),
};

export const DropdownIndicator = ({ ...props }) => {
  return (
    <components.DropdownIndicator {...props}>
      <span className="px-1">
        <BsChevronDown size={13} />
      </span>
    </components.DropdownIndicator>
  );
};

export default function Step1({
  question,
  blacklisted,
  setNextStep,
  setStep2Result,
  setStep3Result,
  countries,
  prevQuestion,
}) {
  const handleNext = (item) => {
    if (item.step_3_result) {
      setStep3Result(item.step_3_result);
    }
    if (item.step_2_result) {
      setStep2Result(item.step_2_result);
    }
    if (item.next === "special") {
      if (prevQuestion.filter((item) => item.id === 2).length > 0) {
        setNextStep(5);
      } else {
        setNextStep("final");
        setStep3Result("no");
      }
    } else {
      setNextStep(item.next);
    }
  };

  const handleSelect1 = (value) => {
    const blacklist = blacklisted.some(
      (item) =>
        item.toLowerCase() === value ||
        value.search(` ${item.toLowerCase()}`) > -1 ||
        value.search(`${item.toLowerCase()} `) > -1
    );

    if (blacklist) {
      setStep2Result("yes");
      setNextStep("final");
    } else {
      setNextStep(3);
    }
  };

  const handleSelect2 = (value) => {
    if (value === "belize") {
      setStep2Result("yes");
      setNextStep("final");
    } else if (value === "none") {
      setNextStep(4);
    } else {
      const blacklist = blacklisted.some(
        (item) =>
          item.toLowerCase() === value ||
          value.search(` ${item.toLowerCase()}`) > -1 ||
          value.search(`${item.toLowerCase()} `) > -1
      );

      if (blacklist) {
        setStep2Result("yes");
        setNextStep("final");
      } else {
        setNextStep(4);
      }
    }
  };

  return (
    <div>
      <p className="mb-2 font-medium text-bbc-accent-2">{question?.title}</p>
      {question?.content && (
        <div dangerouslySetInnerHTML={{ __html: question?.content }} />
      )}
      {question?.answer && (
        <div className="mt-8">
          {question?.answer.map((item, index) => (
            <div className="mb-2 last:mb-0 lg:mb-3" key={index}>
              <button
                className="block w-full rounded-lg border-[0.5px] border-[#007EFF] px-6 py-4 text-left hover:bg-[#007EFF] hover:text-white"
                style={{
                  boxShadow: "4px 4px 8px rgba(196, 196, 196, 0.2)",
                }}
                onClick={() => handleNext(item)}
              >
                {item.name}
              </button>
            </div>
          ))}
        </div>
      )}
      {question?.input && (
        <div className="mt-4 lg:mt-8">
          <div className={`${question?.input?.type == 1 ? "block" : "hidden"}`}>
            <Select
              instanceId="incorporation-nation"
              placeholder="Choose country"
              options={countries}
              onChange={(value) => handleSelect1(value.label.toLowerCase())}
              classNamePrefix="select"
              components={{
                DropdownIndicator,
                IndicatorSeparator: () => null,
              }}
              className={Styles.selectBox}
              styles={customStyles}
            />
          </div>
          <div className={`${question?.input?.type == 1 ? "hidden" : "block"}`}>
            <Select
              instanceId="incorporation-nation"
              placeholder="Choose country"
              options={[{ label: "None", value: "none" }, ...countries]}
              onChange={(value) => handleSelect2(value.label.toLowerCase())}
              classNamePrefix="select"
              components={{
                DropdownIndicator,
                IndicatorSeparator: () => null,
              }}
              className={Styles.selectBox}
              styles={customStyles}
            />
          </div>
        </div>
      )}
    </div>
  );
}
